<app-badges Type="tag" [label]="label"></app-badges>
